import { createContext } from 'react';
export const ChatWrapperContext = createContext({});
export function ChatWrapperProvider(props) {
    const { children, scrollToBottom } = props;
    return <ChatWrapperContext.Provider value={{ scrollToBottom }}>{children}</ChatWrapperContext.Provider>;
}
